import React from 'react';
import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../../services/proptypes';
import GridColumnFlex from '../../GridColumnFlex';

const propTypes = {
  children: ChildrenPropType,
  color: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  width: PropTypes.string,
};

const defaultProps = {
  children: null,
  color: 'transparent',
  primary: false,
  secondary: false,
  width: null,
};

function Color({children, width, primary, secondary, color, ...columnProps}) {
  let extraClasses = '';
  if (primary) {
    extraClasses = ' primary';
  } else if (secondary) {
    extraClasses = ' secondary';
  }

  const styles = primary || secondary ? {} : {backgroundColor: color};

  return (
    <GridColumnFlex
      className={`color-component${extraClasses}`}
      width={width}
      style={styles}
      {...columnProps}
    >
      {children}
    </GridColumnFlex>
  );
}

Color.propTypes = propTypes;
Color.defaultProps = defaultProps;

export default Color;
